import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';

// Import your SVG logo
import logo from '../../assets/favi/aneslogo.svg'; 

const Footer = () => {
  return (
    <footer className="bg-[#0B0E14] border-t border-white/10 pt-20 pb-8 px-6 relative overflow-hidden">
      
      {/* Subtle Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-electric-green/5 blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-16 relative z-10">
        
        {/* Brand Column */}
        <div>
          <Link to="/" className="flex items-center gap-2 mb-6 group w-fit">
            <img 
              src={logo} 
              alt="ANESDEV Logo" 
              className="h-8 w-auto transition-transform duration-300 group-hover:scale-105" 
            />
            <div className="text-2xl font-black tracking-tighter">
              <span className="text-white">ANES</span>
              <span className="text-electric-green drop-shadow-[0_0_8px_rgba(57,255,20,0.5)]">DEV</span>
            </div>
          </Link>
          <p className="text-gray-400 text-sm leading-relaxed pr-4">
            Providing reliable, fast, and efficient IT services that exceed client expectations.
          </p>
        </div>

        {/* Links Column */}
        <div>
          <h4 className="text-white font-bold mb-6 tracking-wide">Links</h4>
          <ul className="text-gray-400 text-sm space-y-3">
            <li>
              <Link to="/privacy-policy" className="hover:text-electric-green hover:translate-x-1 inline-block transition-all duration-300">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" className="hover:text-electric-green hover:translate-x-1 inline-block transition-all duration-300">
                Refund Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-of-service" className="hover:text-electric-green hover:translate-x-1 inline-block transition-all duration-300">
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>

        {/* Menu Column */}
        <div>
          <h4 className="text-white font-bold mb-6 tracking-wide">Menu</h4>
          <ul className="text-gray-400 text-sm space-y-3">
            <li>
              <Link to="/" className="hover:text-electric-green hover:translate-x-1 inline-block transition-all duration-300">
                Home
              </Link>
            </li>
            <li>
              <Link to="/services" className="hover:text-electric-green hover:translate-x-1 inline-block transition-all duration-300">
                Services
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-electric-green hover:translate-x-1 inline-block transition-all duration-300">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Column */}
        <div>
          <h4 className="text-white font-bold mb-6 tracking-wide">Contact</h4>
          <ul className="text-gray-400 text-sm space-y-4">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-electric-green mt-0.5 shrink-0" />
              <span>Austin, Texas</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-electric-green shrink-0" />
              <a href="mailto:contact@anesdev.com" className="hover:text-white transition-colors">
                anesserdev@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-electric-green shrink-0" />
              <a href="tel:++44 7411 585816" className="hover:text-white transition-colors">
                +1 3026623424
              </a>
            </li>
          </ul>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="max-w-7xl mx-auto text-center pt-8 border-t border-white/5 text-gray-500 text-sm relative z-10">
        © 2026 Created by AnesDev. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;